const navbarLinks = [
  { title: 'Home', href: '/' },
  { title: 'Portfolio', href: '/portfolio' },
  { title: 'To Do', href: '/to-do' },
  { title: 'Lorem', href: '/lorem' },
  { title: 'Chat', href: '/chat' }
];

export default navbarLinks;
